import { useLocation } from 'react-router-dom';

/**
 * Hook to determine the current flow type based on the current pathname.
 *
 * @returns 'demo' if the pathname starts with '/demo', otherwise 'signup'
 */
export const useFlowType = (): 'demo' | 'signup' => {
  const location = useLocation();
  return location.pathname.startsWith('/demo') ? 'demo' : 'signup';
};
